import { render } from "./FloatingWhatsappButton.vue?vue&type=template&id=77a8ea0a&scoped=true"
import script from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"

import "./FloatingWhatsappButton.vue?vue&type=style&index=0&id=77a8ea0a&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a8ea0a"]])

export default __exports__